import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { cleanState } from 'coreOld/slices';

const CleanState = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // Every time the route changes clean the table state (selectedRow, selectionMode)
    dispatch(cleanState());
  }, [location.pathname]);

  return <>{children}</>;
};

export default CleanState;
